module.exports = __webpack_public_path__ + "static/media/crane2.70083fb1.png";